export default __webpack_public_path__ + "24ab5859f07e15f026ef9d3c7ab562ce.png";